<template>
  <div id="order-comfirm" class="container-md">
    <order-page-header :order="order" :current-page-order-status="3" :allow-leave.sync="layout.allowLeave"></order-page-header>
    <div class="page-content">
      <div class="customer-phone" v-if="order.peer_user && order.peer_user.mobile_phone">
        <img class="icon" src="https://o.666visa.cn/static/ssqpeer/order/icon-phone.png" alt="">
        <div class="customer-phone-label">顾客电话</div>
        <div class="customer-phone-value">{{order.peer_user.mobile_phone}}</div>
      </div>
      <order-fliggy :ota-info="order.ota_info" v-if="order.ota_info"></order-fliggy>
      <div class="center-content" v-if="order.user_order_id">

        <!--订单收货地址栏-->
        <order-comfirm-return-address
          v-if="!order.hide_return_address"
          :address="returnAddress"
          :supplier-address="order.supplier_address"
          :sf-return-express-price="sfReturnExpressPrice"
          @changeReceiveAddress="changeReceiveAddress"
        ></order-comfirm-return-address>

        <!-- 订单确认信息 -->
        <order-comfirm-infos
          v-model="otherOrderData"
          :disabled-date="disabledDate"
          :holiday-arr="holidayArr"
          :order="order"
          :depart-date-past="departDatePast"
          :effect-date-past="effectDatePast"
          @applicantDelete="applicantDelete"
          @changeDepartDate="changeDepartDate"
          @changeEffectDate="changeEffectDate"
        ></order-comfirm-infos>

        <!-- 拒签无忧 -->
        <order-comfirm-reject-product
          v-if="showRejectProductModule"
          v-model="otherOrderData.reject_product_id"
          :product-detail="productDetail"
          :order="order"
          :order-selected-coupon="coupon.orderSelectedCoupon"
          :coupon-reduce-price="couponReducePrice"
          :reject-product-price="rejectProductPrice"
        >
        </order-comfirm-reject-product>

        <!--平台提供保险 -->
        <order-confirm-insurance
          ref="platformInsuranceCom"
          v-if="getCurrentInsuranceType === 2"
          :order="order"
          :platform_insurance.sync="insurance.platform_insurance"
          :platform_insurance_form.sync="insurance.platform_insurance_form"
        />

        <!-- 记得改成双向绑定的 用户自选保险 -->
        <order-confirm-user-insurance
          ref="userInsuranceCom"
          v-if="getCurrentInsuranceType === 1 && order.offline === 0"
          :order="order"
          :user_insurance.sync="insurance.user_insurance"
          :user_insurance_form.sync="insurance.user_insurance_form"
        />

        <!-- 优惠券列表 -->
        <order-coupons
          v-if="!User.is_palmyou"
          ref="orderCoupons"
          :order-id="orderId"
          :order-use-coupon="coupon.orderUseCoupon"
          :order-coupons="coupon.orderCoupons"
          :order-selected-coupon="coupon.orderSelectedCoupon"
          :order-visa-price="orderVisaPrice"
          :order-special-price="order.special_price"
          :coupon-reduce-price="couponReducePrice"
          @changeSelectedCoupon="(selectedCoupon) => { coupon.orderSelectedCoupon = selectedCoupon; }"
          @changeUseCoupon="(use) => { coupon.orderUseCoupon = use; }"
          @addedCoupon="addedCoupon"
        ></order-coupons>

        <!-- 顺丰 -->
        <order-comfirm-sf
          v-if="isPaperMaterialIncluded || order.offline === 1"
          :sf-checked="sfChecked"
          :order-id="orderId"
          :order="order"
          :addresses="addresses"
          :pick-up-amount-obj="pickUpAmountObj"
          :selected-sf-address="selectedSFAddress"
          @sfSelectChange="(newSFselection) => { sfChecked = newSFselection }"
          @isAllMaterialReady="isAllMaterialReady"
          @SFaddressSelected="SFaddressSelected"
          @editedSfAddress="editedSfAddress"
        ></order-comfirm-sf>

        <!-- 订单联系人信息 -->
        <order-confirm-contact
          v-model="otherOrderData"
          :order="order"
        ></order-confirm-contact>
      </div>
    </div>

    <div class="page-fixed-right">
      <order-confirm-right-fixed
        v-if="order.user_order_id"
        :order="order"
        :total-amount="totalAmount"
        :order-visa-price-total="orderVisaPriceTotal"
        :sf-checked="sfChecked"
        :pickup-amount="pickUpAmountObj.pickup_amount"
        :sf-return-express-price="sfReturnExpressPrice"
        :user-insurance="current_user_insurance"
        :plat-insurance="current_platform_insurance"
        :reject-product-price="rejectProductPrice"
        :show-reject-product-module="showRejectProductModule"
        :order-selected-coupon="coupon.orderUseCoupon ? coupon.orderSelectedCoupon : {}"
        :coupon-reduce-price="couponReducePrice"
      ></order-confirm-right-fixed>
    </div>

    <!-- 确认页底部 -->
    <order-confirm-footer
      v-if="order.user_order_id"
      :order="order"
      :peer="peer"
      :total-amount="totalAmount"
      :loading="queryingReturnExpressData"
      @handleShowRechargeDialog="handleShowRechargeDialog()"
      @pay="commit()"
    ></order-confirm-footer>

    <!-- 所有对话框 -->
    <div class="modals">

      <!-- 出行日期过早 -->
      <depart-date-too-early-modal
        v-model="modifyDepartDateDialog"
        :type = "dateErrorType"
      ></depart-date-too-early-modal>

      <!-- 支付确认 -->
      <pay-ensure-modal
        v-model="payDialog"
        :showLoading="showPayLoading"
        @ensure="orderSubmitAndPay"
      ></pay-ensure-modal>

      <!-- 余额不足 -->
      <insufficient-balance-modal
        v-model="rechargeDialog"
        :order-id="orderId"
        :from="'orderComfirm'"
        :chargePrice="shouldPayPrice - peer.balance_amount"
        :from-param="{ oid: orderId }"
        :from-query="{ sf: sfChecked }"
        @show-recharge="handleShowRechargeDialog(true)"
      ></insufficient-balance-modal>

      <!-- 护照有效期不足 -->
      <date-tip-modal :order="order" :depart-date="otherOrderData.depart_date" ref="dateTip"></date-tip-modal>

      <!-- 充值弹窗 -->
      <recharge-dialog
        v-model="rechargeDialogInfo.show"
        from="orderComfirm"
        :show-pay-now-checkbox="rechargeDialogInfo.showPayNowCheckbox"
        @recharge-success="rechargeSuccess"
      >
      </recharge-dialog>

      <!-- 同业补充邮箱 -->
      <peer-email-modal v-model="showPeerEmailModal" @updatePeerEmail="updatePeerEmail"></peer-email-modal>
    </div>


    <!-- 权益活动: 三单挑战和满额活动 -->
    <equity-activity-dialog
      v-if="equityActivityModal.show"
      :visible="equityActivityModal.show"
      :full-order-activity="equityActivityModal.activityInfo"
      @close="equityActivityModal.show=false"
      :resolve="equityActivityModal.equityActivityDialogResolve">
    </equity-activity-dialog>

  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import {
  PAY_OK,
} from '@/store/modules/follow-official-accounts/follow-official-accounts-types';

import utils from '../../libs/utils';
import Http from '../../libs/http';
import addressUtils from '../../libs/address-utils';
import User from '../../libs/user';

import SFService from '../../services/sf-service';
import pcdService from '../../services/pcd-service';
import orderingService from '../../services/ordering-service';
import orderComfirmService from '../../services/order-comfirm-service';
// import orderService from '../../services/order-service';
import addNewOrderService from '../../services/add-new-order-service';

import departDateTooEarlyModal from './modals/depart-date-too-early-modal';
import payEnsureModal from './modals/pay-ensure-modal';
import insufficientBalanceModal from './modals/insufficient-balance-modal';
import orderingBread from './components/ordering-bread';
import orderingOrderBasicInfo from './components/ordering-order-basic-info';
import orderComfirmRejectProduct from './components/order-comfirm-reject-product';
import firstPrice from './components/first-price';
import orderComfirmInfos from './components/order-comfirm-infos';
import orderComfirmPayInfo from './components/order-comfirm-pay-info';
import orderComfirmReturnAddress from './components/order-comfirm-return-address';
import orderComfirmSf from './components/order-comfirm-sf';
import productService from '../../services/product-service';
import orderCoupons from './components/order-coupons';
import couponService from '../../services/coupon-service';

import orderConfirmInsurance from './components/order-confirm-insurance';
import orderConfirmUserInsurance from './components/order-confirm-user-insurance';
// import insurancePopup from '../businessInsurance/popupBox/index';
import orderFliggy from './components/order-fliggy';
import dateTipModal from './modals/date-tip-modal';

import orderPageHeader from './components/order-page-header';
import orderConfirmContact from './components/order-confirm-contact';
import rechargeDialog from '../../components/common/recharge-dialog';
import validates from '../../libs/validates';
import peerEmailModal from './modals/supplement-peer-email-modal.vue';
import equityActivityDialog from '@/pages/index/components/equity-activity-dialog/equity-activity-dialog.vue';
import OrderConfirmFooter from './components/order-confirm-footer.vue';
import orderConfirmRightFixed from './components/order-confirm-right-fixed.vue';
import animationService from '@/services/animation-service';
import orderConfirmBackDialog from './components/order-confirm-back-dialog/index';
import fliggyService from '@/services/modules/fliggy-service';
import insuranceService from '@/services/insurance-service';

export default {
  name: 'order-comfirm',
  components: {
    firstPrice,
    orderCoupons,
    orderingBread,
    orderComfirmSf,
    payEnsureModal,
    orderComfirmInfos,
    orderComfirmPayInfo,
    orderingOrderBasicInfo,
    orderComfirmRejectProduct,
    departDateTooEarlyModal,
    insufficientBalanceModal,
    orderComfirmReturnAddress,
    orderConfirmInsurance,
    orderFliggy,
    dateTipModal,
    orderPageHeader,
    orderConfirmContact,
    rechargeDialog,
    orderConfirmUserInsurance,
    peerEmailModal,
    equityActivityDialog,
    OrderConfirmFooter,
    orderConfirmRightFixed,
  },
  data() {
    return {
      User,
      paying: false, // 支付中
      payDialog: false, // 支付提示
      addresses: [], // 所有地址数组
      holidayArr: [], // 处理国的放假日期
      holidays: [], // 国家放假日历原始数据
      disabledDate: '', // 不可用日期
      returnAddress: {}, // 选择的收件地址
      queryingReturnExpressData: false,
      selectedSFAddress: {}, // 选择的顺丰地址
      isPaperMaterialIncluded: false, // 是否包含纸质资料
      sfChecked: this.$route.query.sf === 'true', // 是否选择顺丰上门取件
      rechargeDialog: false, // 显示充值对话框
      pickUpAmountObj: { pickup_amount: 0 }, // 顺丰上门取资料信息
      orderId: +this.$route.params.oid, // 参数订单号
      pcds: {}, // 省市区数据
      order: {}, // 订单
      otherOrderData: { // 非资料相关的其他字段
        depart_date: '', // 出行日期
        effect_date: '', // 生效日期
        contact_name: '', // 联系人名
        contact_phone: '', // 联系人手机号
        contact_email: '',
      },
      coupon: {
        orderCoupons: [], // 订单可用优惠券列表
        orderUseCoupon: false, // 订单是否使用优惠券
        orderSelectedCoupon: {}, // 订单已选择的优惠券
      },
      sfReturnExpressPrice: 0, // 顺丰回寄费用
      peer: { balance_amount: 0 }, // 同业用户信息
      modifyDepartDateDialog: false, // 是否显示修改出行日期对话框
      dateErrorType: 1, // 日期错误类型。1 为出行日期错误；2 为生效日期错误
      departDatePast: false, // 出行日期是否过期
      effectDatePast: false, // 生效日期是否过期
      interviewFormDataErrorMap: null, // 面试表单错误
      interviewformData: null, // 面试数据
      earlistDateData: null, // 最早赴馆日期信息
      shouldPayPrice: 0,
      rechargeDialogInfo: {
        show: false,
        showPayNowCheckbox: false,
      },
      insurance: {
        user_insurance: [], // 用户自选保险列表
        user_insurance_form: {
          insurance_id: 0, // 选中的用户保险ID
          start_date: '',
          insurance_day_index: 0,
          over_day_index: 0,
          ensure: true,
        },
        platform_insurance: [], // 平台保险列表
        platform_insurance_form: {
          insurance_id: 0, // 平台保险id
          insurance_day_index: 0, // 平台保险保障天数
          over_day_index: 0, // 平台保险保障额外天数
          ensure: true,
        },
      },
      productDetail: null, // 商品详情
      showPeerEmailModal: false, //  同业邮箱的补充
      showPayLoading: false, // 展示支付loading
      equityActivityModal: { // 权益活动弹窗
        show: false,
        activityInfo: {},
        equityActivityDialogResolve: undefined,
      },
      layout: {
        allowLeave: false, // 是否允许离开，如果允许离开，则不弹出二次确认
      },
    };
  },
  computed: {
    // 当前选中的用户保险
    current_user_insurance() {
      return this.insurance.user_insurance.find(item => item.insurance_id === this.insurance.user_insurance_form.insurance_id);
    },
    getCurrentInsuranceType() {
      if (this.order && this.order.product_insurance_new && this.order.product_insurance_new.length > 0) {
        return this.order.product_insurance_new[0].insurance_type;
      }
      return '';
    },
    current_platform_insurance() {
      return this.insurance.platform_insurance.find(item => item.insurance_id === this.insurance.platform_insurance_form.insurance_id);
    },
    orderVisaPrice() {
      if (this.order && this.order.applicant && this.order.applicant.length) {
        return this.order.applicant[0].sell_price * this.order.applicant.length;
      }
      return 0;
    },
    
    // 拒签无忧价格
    rejectProductPrice() {
      if (!this.productDetail || !this.otherOrderData.reject_product_id) return 0;

      const curRejectProduct = this.productDetail.reject_product_set.find(item => item.reject_product_id === this.otherOrderData.reject_product_id);
      if (!curRejectProduct) return 0;
      return curRejectProduct.sell_price * this.order.applicant.length;
    },
    // 是否显示拒签无忧模块
    showRejectProductModule() {
      return this.productDetail && this.productDetail.reject_product_set && this.productDetail.reject_product_set.length > 0;
    },

    // 订单签证价格(特价商品使用特价)
    orderVisaPriceTotal() {
      return (
        this.order.special_price ?
          this.order.special_price :
          this.order.applicant[0].sell_price
      ) * this.order.applicant.length;
    },
    // 优惠券减免价格
    couponReducePrice() {
      // 没有勾选优惠券
      if (!this.coupon.orderUseCoupon || !this.coupon.orderSelectedCoupon) return 0; 

      const discount_amount = this.coupon.orderSelectedCoupon.discount_amount;

      return this.orderVisaPriceTotal > discount_amount ? discount_amount : this.orderVisaPriceTotal;
    },

    // 订单总额
    totalAmount() {

      let amount = this.orderVisaPriceTotal;

      // 优惠券(特价商品不能使用优惠券)
      if (!this.order.special_price && this.coupon.orderUseCoupon && this.coupon.orderSelectedCoupon && this.coupon.orderSelectedCoupon.id) {
        amount -= this.couponReducePrice;
      }

      // 选中顺丰就要加上顺丰取资料费用
      if (this.sfChecked) {
        amount += this.pickUpAmountObj.pickup_amount;
      }

      // 回寄运费
      if (this.sfReturnExpressPrice) {
        amount += this.sfReturnExpressPrice;
      }
      // 保险
      if (this.getCurrentInsuranceType === 2) {
        // 平台保险
        amount += this.current_platform_insurance.insurance_fee !== undefined ? this.current_platform_insurance.insurance_fee * this.order.applicant.length : 0;
      } else if (this.getCurrentInsuranceType === 1 && this.current_user_insurance) {
        // 用户自选保险
        amount += this.current_user_insurance.insurance_fee !== undefined ? this.current_user_insurance.insurance_fee * this.current_user_insurance.insurance_discount : 0;
      }

      // 拒签无忧
      if (this.showRejectProductModule) {
        amount += this.rejectProductPrice;
      }
      
      return amount;
    },
    

  },
  methods: {
    ...mapMutations('followOA', [
      PAY_OK,
    ]),
    initInsurance() {
      if (!this.order.product_insurance_new || this.order.product_insurance_new.length === 0) return;
      // 用户保险
      if (
        this.order.product_insurance_new[0].insurance_type === 1 && 
        this.order.offline === 0
      ) {
        // 自选保险
        // 如果已经初始化过，则不重复初始化
        if (this.insurance.user_insurance.length) {
          return;
        }
        this.insurance.user_insurance = this.order.product_insurance_new.map(item => ({
          ...item,
          insurance_fee: undefined,
          insurance_discount: 1,
        }));
        if (this.order.product_need_insurance) {
          // 找到设置为推荐的 否则默认选中第一个
          let defaultPlanId = this.order.product_insurance_new.findIndex(item => item.is_default);
          defaultPlanId = defaultPlanId === -1 ? 0 : defaultPlanId;
          this.insurance.user_insurance_form.insurance_id = this.insurance.user_insurance[defaultPlanId].insurance_id;
        }
        
        if (this.isNeedShowDepartDateModifyDiolog()) {
          // 出行日期合格
          this.insurance.user_insurance_form.start_date = this.order.depart_date;
        }
      } else if (this.order.product_insurance_new[0].insurance_type === 2) {
        // 平台保险
        this.insurance.platform_insurance = this.order.product_insurance_new.map(item => ({
          ...item,
          insurance_fee: undefined,
        }));
        // 找到设置为推荐的 否则默认选中第一个
        let defaultPlanId = this.order.product_insurance_new.findIndex(item => item.is_default);
        defaultPlanId = defaultPlanId === -1 ? 0 : defaultPlanId;
        this.insurance.platform_insurance_form.insurance_id = this.insurance.platform_insurance[defaultPlanId].insurance_id;
      }
    },

    totalPayAmount(shouldPayPrice) {
      this.shouldPayPrice = shouldPayPrice;
    },

    getAddress: addressUtils.getAddress,

    // 顺丰地址切换
    SFaddressSelected({ data, address }) {
      this.pickUpAmountObj = data;
      // 更新订单顺丰地址
      if (this.order.order_pickup) {
        this.order.order_pickup[0].address = address;
      } else {
        this.order.order_pickup = [{ address }];
      }
      this.order.supplier_address = data.supplier_address;
    },

    // 编辑了顺丰地址
    editedSfAddress(postData) {
      this.selectedSFAddress = postData;
      this.recalculateSfPriceForChoosing(postData);
    },

    // 确认所有资料已备齐(顺丰需要处理)
    isAllMaterialReady() {

      // 若之前已有选择顺丰地址，那么需要刷新供应商地址和价格
      if (this.selectedSFAddress.province_code) {
        this.recalculateSfPriceForChoosing(this.selectedSFAddress);
      }
    },

    // 专门检查赴馆日期是否有过期
    checkInterviewDateOutDated() {
      const applicant = [];
      // const paddingDayNum = this.order.need_delivery > 0 ? 2 : 4;
      // const closestDateStr = dateUtils.getClosestDate(paddingDayNum, this.holidays).format('yyyy-MM-dd');
      this.interviewformData.data.forEach((item, index) => {
        let applicantInterviewDateIsOutdated = false;
        if (item.date_choice === 0) {
          let closestDateStr;
          if (this.earlistDateData.city_date && this.earlistDateData.city_date.length) {
            const chooseItem = this.earlistDateData && this.earlistDateData.city_date.filter(city => city.embassy_district_id === item.embassy_district_id).pop();
            closestDateStr = chooseItem && chooseItem.earliest_date;
          } else {
            closestDateStr = this.earlistDateData.default_date;
          }
          closestDateStr = new Date(closestDateStr).format('yyyy-MM-dd');
          item.preferred_date.forEach((itm, idx) => {
            if (itm.date < closestDateStr || this.holidays.indexOf(itm.date) > -1) {
              applicantInterviewDateIsOutdated = true;
              this.interviewFormDataErrorMap[index][0][idx] = true;
            }
          });
          applicantInterviewDateIsOutdated && applicant.push(item);
        }
      });
      const interviewDateIsOutdated = applicant.length >= 1;
      if (interviewDateIsOutdated) {
        this.promptForInterviewDate(this.interviewformData.interview_together, applicant);
      }
      return interviewDateIsOutdated;
    },
    // 检查所有资料是否都填写完成
    checkUploadMaterial() {
      return this.order.applicant.every(applicant => orderingService.getProgress(applicant) === 100);
    },

    /**
     * 所有申请人的申请表是否填写完成
     * @param {*} order
     */
    checkApplication() {
      return this.order.applicant.every((applc) => {
      // 需要申请表，但是申请表的状态为待上传，则不通过
        if (applc.application && applc.application.application_status === 1) {
          return false;
        }
        return true;
      });
    },

    // 提示
    promptForInterviewDate(interviewTogether, applicant) {
      utils.msgbox.alert(
        interviewTogether ? '上次选择的最佳赴馆日期已经过期了哦，请您重新选择' :
          `${applicant[0].applicant_name}${applicant.length === 1 ? '' : '等人'}的最佳赴馆日期已经过期了哦，请您重新选择`,
        '重要提示',
        {
          confirmButtonText: '重新选择',
          callback: (action) => {
            if (action === 'confirm') {
              this.goBackToInterviewSelect();
            }
          },
        },
      );
    },

    // 返回
    goBackToInterviewSelect() {
      const allSteps = orderingService.getOrderSteps(this.order);
      let idx = null;
      allSteps.forEach((tab, index) => {
        if (tab.className === 'interview') {
          idx = index;
        }
      });
      this.$router.push(allSteps[idx].routeConfig);
    },

    changeDepartDate() {
      this.departDatePast = false;
      // 校验生效日期是否合法
      if (this.order.need_effect_date) {
        const effectDatePass = this.isNeedShowEffectDateModifyDiolog();
        if (!effectDatePass) return;
      }
      // 检查赴馆日期
      if (!this.modifyDepartDateDialog && (this.order.need_delivery > 0 || this.order.need_interview > 0)) {
        this.getEarlistDateData().then(() => {
          this.checkInterviewDateIsOutDatedIfNeeded();
        });
      }
      // 自选保险,如果当前生效日期没选，则赋值为出行日期
      if (
        this.getCurrentInsuranceType === 1 &&
        this.order.offline === 0 &&
        !this.insurance.user_insurance_form.start_date
      ) {
        this.insurance.user_insurance_form.start_date = this.otherOrderData.depart_date;
      }
    },
    changeEffectDate() {
      this.effectDatePast = false;
      // 检查赴馆日期
      if (!this.modifyDepartDateDialog && (this.order.need_delivery > 0 || this.order.need_interview > 0)) {
        this.getEarlistDateData().then(() => {
          this.checkInterviewDateIsOutDatedIfNeeded();
        });
      }
    },

    // 验证选择日期结果是否合法(已确认)
    validateInterviewDateExpired() {

      // 先重新初始化错误map
      this.interviewFormDataErrorMap = this.interviewformData.data.map(() => ({
        0: [false, false, false],
        2: false,
      }));
      if (this.interviewformData.interview_together === 1) {
        const togetherData = this.interviewformData.data[0];
        this.interviewformData.data = this.interviewformData.data.map(({ order_applicant_id }) =>
          utils.extend({}, togetherData, { order_applicant_id }));
      }
      let valid = true;
      this.interviewformData.data.forEach((item, index) => {
        if (item.date_choice === 0) {
          item.preferred_date.forEach((date, idx) => {
            if (!date.date) {
              valid = false;
              this.interviewFormDataErrorMap[index][0][idx] = true;
            }
          });
        } else if (item.date_choice === 2) {
          if (item.other_date === '') {
            valid = false;
            this.interviewFormDataErrorMap[index][2] = true;
          }
        }
      });
      return valid;
    },

    // 满足条件才会检查赴馆日期是否有过期
    checkInterviewDateIsOutDatedIfNeeded() {
      if (this.validateInterviewDateExpired() && !this.modifyDepartDateDialog) { // 通过校验才检查是否有日期过期
        return this.checkInterviewDateOutDated();
      }
    },

    // 获取国家放假信息
    getCountryHoliday() {
      orderingService.countryHolidayQuery(this.order.visa_country_id).then((data) => {
        if (!Object.keys(data).length) return;

        // 预约数据
        this.interviewformData = orderingService.extractInterviewInfo(this.order);

        // 放假信息
        this.holidays = data[Object.keys(data)[0]];

        // 不可用日期
        this.disabledDate = addNewOrderService.handleDisabledDate(this.order.earliest_depart_date);

        // 格式化给出行日期选择项用
        this.holidayArr = orderComfirmService.formatHoliday(this.holidays, this.disabledDate);

        // 如果是面试面递订单，获取最早赴馆日期并检查是否有赴馆日期过期
        if (this.order.need_delivery > 0 || this.order.need_interview > 0) {
          this.getEarlistDateData().then(() => {
            this.checkInterviewDateIsOutDatedIfNeeded();
          }).catch((e) => {
            if (e) console.log(e);
          });
        }
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 跳转到指定元素，并抖动
    scrollToElAndShake(selector, shakeSelector) {
      const el = document.querySelector(selector);
      if (!el) return;
      window.scrollTo({
        top: el.offsetTop,
        behavior: 'smooth',
      });
      setTimeout(() => {
        animationService.addAnimationClass(shakeSelector || selector, 'global-shake-x');
      }, 600);
    },

    // 支付校验
    commit(options = {}) {

      if (!this.order.hide_return_address && !this.returnAddress.addressee) {
        this.scrollToElAndShake('#order-comfirm #order-comfirm-return-address-new');
        return utils.msg.warning('请选择收货地址！');
      }

      // 确认出行日期是否不合法(过期)
      if (!this.isNeedShowDepartDateModifyDiolog(true)) {
        this.scrollToElAndShake('#order-comfirm #order-comfirm-infos');
        return;
      }

      // 订单支付提交验证，由弹窗提示改为 toast 提示
      if (this.order.need_effect_date) {
        if (!this.otherOrderData.effect_date) {
          this.scrollToElAndShake('#order-comfirm #order-comfirm-infos');
          this.$message.error('请选择签证生效日期');
          return;
        } else if (!this.isNeedShowEffectDateModifyDiolog(true)) {
          this.scrollToElAndShake('#order-comfirm #order-comfirm-infos');
          // 确认生效日期是否不合法(过期)
          return;
        }
      }

      // 确认所有上传资料是否OK
      if (!this.order.offline) {
        if (!this.checkUploadMaterial() || !this.checkApplication()) {
          utils.msg.error('资料不完整，请在资料上传页完善信息！');
          return;
        }
      }


      // 校验护照有效期
      this.$refs.dateTip.showDateTipInit().then(() => {
        // 这里是处理预约时间过期的
        const isNeedVaild = this.order.need_delivery > 0 || this.order.need_interview > 0;
        const interviewDateIsOutdated = isNeedVaild ? this.checkInterviewDateOutDated() : false;
        

        if (!interviewDateIsOutdated) {

          const phoneReg = /^[1][0-9]{10}$/;
          if (!this.order.hide_return_address && !this.returnAddress.addressee) {
            this.scrollToElAndShake('#order-comfirm #order-comfirm-return-address-new');
            return utils.msg.warning('请选择收货地址');
          }

          if (this.sfChecked && !this.selectedSFAddress.peer_address_id) {
            this.scrollToElAndShake('#order-comfirm #order-comfirm-sf');
            return utils.msg.warning('请选择顺丰上门取件地址');
          }

          if (!this.otherOrderData.contact_name || !this.otherOrderData.contact_phone) {
            this.scrollToElAndShake('#order-comfirm .order-confirm-contact');
            return utils.msg.warning('请填写订单联系人信息！');
          }

          if (!phoneReg.test(this.otherOrderData.contact_phone.trim())) {
            this.scrollToElAndShake('#order-comfirm .order-confirm-contact');
            return utils.msg.warning('请输入正确的订单联系人电话号码！');
          }

          if (this.order.hide_return_address) {
            // 隐藏地址，才需要联系邮箱
            // 如果同业没邮箱 弹框  有邮箱但是删了 谈toast
            if (!this.otherOrderData.contact_email && !this.order.contact_email) {
              return this.showPeerEmailModal = true;
            } else if (!validates.inputRegexpCollection.emailReg.test(this.otherOrderData.contact_email)) {
              this.scrollToElAndShake('#order-comfirm .order-confirm-contact');
              return utils.msg.warning('请填写正确的联系邮箱');
            }
          }
          if (this.getCurrentInsuranceType === 1 && this.insurance.user_insurance_form.insurance_id && !this.insurance.user_insurance_form.start_date) {
            this.scrollToElAndShake('#order-comfirm .order-insurance');
            return utils.msg.warning('请选择保险生效日期');
          }
          if (this.getCurrentInsuranceType === 1 && this.insurance.user_insurance_form.insurance_id && !this.insurance.user_insurance_form.ensure) {
            this.scrollToElAndShake('#order-comfirm .order-insurance');
            return utils.msg.warning('请先勾选保险条款等说明');
          }
          if (this.getCurrentInsuranceType === 2 && !this.insurance.platform_insurance_form.ensure) {
            this.scrollToElAndShake('#order-comfirm .order-insurance');
            return utils.msg.warning('请先勾选保险条款等说明');
          }

          // 满足条件之后才可以支付 (reject后promise是不可以再通过.then()传递下去的)
          // 校验价格
          this.checkOrderPrice(true)
            .then(() => this.checkSupplierAddressChange()) // 校验供应商地址是否变更
            .then(async () => {
              // 校验飞猪信息
              try {
                if (!this.order.ota_info) return;
                const { isSuccess, data } = await fliggyService.checkFliggyStatus(this.order.ota_info, {
                  ota_order_status: true,
                  ota_applicant_status: true,
                });

                // 更新最新的状态
                if (data) this.order.ota_info.status = data.ota_order_status;
                if (!isSuccess) return Promise.reject();
              } catch (error) {
                return Promise.reject();
              }
            })
            .then(() => new Promise((resolve, reject) => {
              if (User.is_palmyou) {
                if (this.order.business_order_id) {
                  this.$router.replace({
                    name: 'payConfirm',
                    params: {
                      oid: this.orderId,
                    },
                    query: {
                      typeid: 1,
                      payPrice: this.totalAmount / 100,
                    },
                  });
                }
                return this.submitInsurance().then(() => this.orderSubmit()).then(() => {
                  if (this.totalAmount === 0) {
                    this.orderPay();
                  } else {
                    this.$router.replace({
                      name: 'payConfirm',
                      params: {
                        oid: this.orderId,
                      },
                      query: {
                        typeid: 1,
                        payPrice: this.totalAmount / 100,
                      },
                    });
                  }
                });
              }
              orderComfirmService.peerQuery().then((data) => {
                this.peer = data;
                if (data.balance_amount >= this.totalAmount) {
                  resolve();
                } else {
                  // 显示余额不足弹窗
                  this.rechargeDialog = true;

                  reject();
                }
              });
            }))
            .then(() => {
              if (options.notConfirmPay) {
                // 不需要确认，直接跳过
                this.orderSubmitAndPay();
              } else {
                this.payDialog = true;
              }
            })
            .catch(this.handleCheckOrderPriceCatch);

        }
      });

    },

    // 处理价格变化的catch
    handleCheckOrderPriceCatch(errMsg) {

      // 有错误消息代表是价格有变化
      if (errMsg) {
        setTimeout(() => {
          this.layout.allowLeave = true;
          window.location.reload();
        }, 1000);
      }
    },

    // 获取拒签无忧需要上传的参数
    getRejectProductParams() {
      let rejectProduct;
      // 拒签无忧产品是否选中，如果有则筛选出对应的商品信息给后端进行判断是否变更
      if (this.productDetail && this.productDetail.reject_product_set && this.otherOrderData.reject_product_id) {
        rejectProduct = this.productDetail.reject_product_set.find(item => item.reject_product_id === +this.otherOrderData.reject_product_id);
      }
      if (!rejectProduct) return;
      return {
        ratio: rejectProduct.ratio,
        reject_product_id: rejectProduct.reject_product_id,
        sell_price: rejectProduct.sell_price,
      };
    },

    // 更新邮箱
    updatePeerEmail(email) {
      this.otherOrderData.contact_email = email;
    },

    // 提交订单
    orderSubmit() {
      return Http.post('/order_submit', {
        user_order_id: this.orderId,
        peer_coupon_id: (!this.order.special_price && this.coupon.orderSelectedCoupon && this.coupon.orderSelectedCoupon.id) ? this.coupon.orderSelectedCoupon.id : undefined,
        need_pickup: this.sfChecked ? 1 : 0,
        content: this.otherOrderData.guest_content,
        depart_date: this.otherOrderData.depart_date ? this.otherOrderData.depart_date.format('yyyy-MM-dd') : this.order.depart_date,
        contact_name: this.otherOrderData.contact_name ? this.otherOrderData.contact_name : this.order.contact_name,
        contact_number: this.otherOrderData.contact_phone ? this.otherOrderData.contact_phone : this.order.contact_number,
        contact_email: this.order.hide_return_address ? this.otherOrderData.contact_email : '',
        need_insurance: this.insurance.user_insurance_form.insurance_id ? 1 : 0,
        reject_product_id: this.otherOrderData.reject_product_id || undefined,
      });
    },

    // 提交订单并支付
    orderSubmitAndPay() {
      if (this.showPayLoading) return;
      MtaH5.clickStat('payvisaorder0confirm');

      this.showPayLoading = true;
      if (this.otherOrderData.guest_content === '') {
        this.otherOrderData.guest_content = this.otherOrderData.guest_content.trim();
      }
      this.submitInsurance().then(() => this.orderSubmit()).then(() => {
        this.order.order_status = 3;
        
        return this.orderPay();
      }).finally(() => {
        this.showPayLoading = false;
      });
    },

    // 支付处理
    orderPay() {
      return Http.post('/order_pay', {
        user_order_id: this.orderId,
      })
        .then((res) => {
          utils.msg.success('支付成功');
          this.PAY_OK({ payok: true });
          return res;
        })
        .then((res) => { 
          this.payDialog = false;// 先关闭再弹窗
          return Promise.resolve(res && res.peer_activity_record_id ? this.getEquityActivity() : null);
        })
        .then(() => {
          this.layout.allowLeave = true;
          this.$router.replace({ name: 'orderDetail', params: { oid: this.orderId }, query: { admin: this.$route.query.admin } });
        })
        .finally(() => {
          this.payDialog = false;
        });
    },

    // 是否显示权益活动： 三单活动+满额活动
    getEquityActivity() {
      return new Promise((resolve, reject) => {
        Http.post('/full_order_activity_query', { is_need_complete_coupon: 1 }).then((data) => {
          this.equityActivityModal.activityInfo = data.full_order_activity;
          if (data.full_order_activity && data.full_order_activity.remaining_seconds) { // 是否过期 + 或者完成
            this.equityActivityModal.show = true;
            // 存储resolve传入弹窗，等待关闭时候再进行resolve
            this.equityActivityModal.equityActivityDialogResolve = resolve;
            return; 
          }
          resolve();
          
        }).catch(() => {
          reject();
        });
      });
    },

    // 获取商品详情进行拒签无忧商品的获取
    getProductDetail(visa_product_id) {
      orderingService.getProductData(visa_product_id).then((data) => {
        this.productDetail = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 获取订单信息
    getOrder() {
      return orderingService.getOrderData(this.orderId).then((data) => {
        document.title = `${data.country}国家签证办理-上上签同业签证平台，旅游同业签证办理的智能平台`;

        // 判断是否已支付过
        if (data.pay_info && data.pay_info.pay_status > 0) {
          utils.msg.warning('订单已支付');
          this.layout.allowLeave = true;
          return this.$router.replace({ name: 'orderDetail', params: { oid: this.orderId } });
        }

        this.order = data;

        // 获取商品详情
        this.getProductDetail(data.visa_product_id || '');

        // 判断此订单是否含有纸质资料
        this.isPaperMaterialIncluded = SFService.isPaperMaterialIncluded(data.applicant);

        // 设置上次选择的顺丰信息
        this.setLastShunfengInfo(data);

        // 初始化其他字段信息
        this.initOrderOtherFormData(data);

        // 检查爆款商品和价钱等
        this.checkOrderPrice().catch(this.handleCheckOrderPriceCatch);

        // 重新计算顺丰的价格
        this.recalculateSfPrice();

        // 确认出行日期是否不合法(过期)
        const departDateError = this.isNeedShowDepartDateModifyDiolog();

        // 如果出行日期合法，则校验生效日期是否合法
        if (this.order.need_effect_date && departDateError) {
          this.isNeedShowEffectDateModifyDiolog();
        }


        // 初始化保险
        this.initInsurance();

        // 获取国家放假信息以及格式化
        this.getCountryHoliday();

        // 获取订单优惠券
        this.getOrderCoupons(this.orderId);
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 获取最早赴馆日期信息
    getEarlistDateData() {
      return orderingService.getEarlistDateData(this.orderId).then((data) => {
        this.earlistDateData = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    addedCoupon() {
      // 获取订单优惠券
      this.getOrderCoupons(this.orderId, true);
    },

    // 获取订单的优惠券
    getOrderCoupons(orderId, addedCoupon) {

      this.coupon = {
        orderCoupons: [],
        orderUseCoupon: false,
        orderSelectedCoupon: {},
      };

      couponService.orderCouponQuery({
        user_order_id: orderId,
      }).then((data) => {
        this.coupon.orderCoupons = data.available_coupon;

        // 加载完成了，还没有选中任何优惠券默认选中第一张
        if (!addedCoupon && !this.coupon.orderSelectedCoupon.id && this.coupon.orderCoupons) {
          this.coupon.orderUseCoupon = true;
          this.coupon.orderSelectedCoupon = this.coupon.orderCoupons[0];
        }

        // 添加完优惠券只有一张优惠券需要默认选中
        if (addedCoupon) {
          this.coupon.orderUseCoupon = true;
          this.coupon.orderSelectedCoupon = this.coupon.orderCoupons[0];
        }

      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 是否需要显示出行日期不合法的对话框
    isNeedShowDepartDateModifyDiolog(isSubmit) {
      const date = isSubmit ? this.otherOrderData.depart_date : this.order.depart_date;

      // 没有选择出行日期
      if (!date) {
        this.modifyDepartDateDialog = true;
        utils.scrollTop();
        this.departDatePast = true;
        return false;
      }

      // 最早出行日期的前一天 也就是 禁用日期
      const minDate = addNewOrderService.handleDisabledDate(this.order.earliest_depart_date);

      // 判断赴馆时间是否过期
      // 最小日期已经大于出行日期了，就要将出行日期清空
      if (minDate >= date) {
        this.modifyDepartDateDialog = true;
        this.otherOrderData.depart_date = '';
        this.departDatePast = true;
        utils.scrollTop();
        return false;
      }

      return true;
    },

    isNeedShowEffectDateModifyDiolog(isSubmit) {
      const date = isSubmit ? this.otherOrderData.effect_date : this.order.effect_date;

      // 没有选择生效日期
      if (isSubmit && !date) {
        this.modifyDepartDateDialog = true;
        this.effectDatePast = true;
        this.dateErrorType = 2;
        utils.scrollTop();
        return false;
      }

      // 如果生效日期小于等于今天（理论上是不会到这里）
      if (date && new Date(date) <= new Date()) {
        this.modifyDepartDateDialog = true;
        this.effectDatePast = true;
        this.dateErrorType = 2;
        this.otherOrderData.effect_date = '';
        utils.scrollTop();
        return false;
      }
      return true;
    },

    // 检测是否为爆款或者商品价格是否已发生变化，传入true表示发起支付
    checkOrderPrice(isPay) {
      return new Promise((resolve, reject) => {

        // 支付需要重新加载订单信息
        const orderDataPromise = isPay ? orderingService.getOrderData(this.orderId) : Promise.resolve(this.order);

        orderDataPromise.then((data) => {

          // 检查是否已经支付了
          if (data.pay_info && data.pay_info.pay_status > 0) {
            utils.msg.warning('订单已支付');
            this.$router.replace({ name: 'orderDetail', params: { oid: this.orderId } });
            return reject();
          }

          // 检查订单价格
          // this.order.first_order_reduce ? 1 : 0,
          return orderComfirmService.orderPriceDetect(this.order.user_order_id, this.coupon.orderSelectedCoupon ? this.coupon.orderSelectedCoupon.id : undefined, this.getRejectProductParams());
        }).then((data) => {

          // 商品下架时 就不做任何操作
          if (JSON.stringify(data) === '{}') {
            return resolve();
          }

          // 价格有变化
          if (data.price_changed) {
            utils.msg.warning(data.reason);

            // 注意只在这里把错误消息放了进去, 因为只在提交的时候处理这个情况, 有错误消息代表价格发生变化, 那边会刷新整个页面
            return reject(data.reason);
          }

          return resolve();
        }).catch((e) => {
          if (e) console.log(e);
        });
      });
    },

    // 进入订单确认页面，刷新供应商地址，重新计算顺丰价格
    recalculateSfPrice() {
      const { need_pickup, order_pickup, user_order_id } = this.order;

      if (need_pickup === 0 || !order_pickup || order_pickup.length === 0) return;

      const addressObj = order_pickup && order_pickup[0].address;
      const postData = {
        user_order_id,
        address: addressObj,
      };

      orderComfirmService.pickUpSubmit(postData).then((data) => {
        this.pickUpAmountObj = data;
        this.order.supplier_address = data.supplier_address;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 重新进入页面传入上次选的顺丰上门取件信息
    setLastShunfengInfo(order) {

      // 已经选了顺丰, 但是却没有支付的情况, 因为顺丰是要根据点的地址计算价钱的
      if (order.order_pickup && order.order_pickup.length > 0) {

        // 读取order_query里面的信息，填入上次选择的顺丰地址和对应价格
        this.selectedSFAddress = SFService.getSfAddress(order, this.addresses);
        this.sfChecked = true;
        this.pickUpAmountObj.pickup_amount = order.order_pickup[0].pickup_amount;
        this.pickUpAmountObj.original_price = order.order_pickup[0].original_price;
      }
    },

    // 初始化其他字段的数据
    initOrderOtherFormData(order) {
      this.otherOrderData = {
        depart_date: new Date(order.depart_date), // 出行日期
        effect_date: order.effect_date ? new Date(order.effect_date) : '', // 生效日期
        contact_name: order.contact_name, // 联系人名字
        contact_phone: order.contact_number, // 联系手机号
        contact_email: order.contact_email,
        guest_content: order.content, // 顾客留言
      };
    },

    // 获取同业所有地址
    getAddresses(order) {
      orderComfirmService.peerAddressBriefQuery().then((res) => {
        const data = res.result;
        this.addresses = data;
        this.selectedSFAddress = SFService.getSfAddress(this.order, data);
        if (order.hide_return_address) return;
        
        if (!this.returnAddress.province_code) {
          let address = {};
          if (order.return_address && order.return_address.addressee) {
            address = order.return_address;
          } else {
            address = data.filter(peerAddress => peerAddress.is_default)[0] || {};
          }
          this.returnAddress = address;
          if (this.returnAddress.province_code) {
            this.submitReturnAddress(this.returnAddress);
          }
        }
        
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 获取顺丰回寄费用
    getReturnExpressPrice(returnAddress, order, oldOrder) {

      // 订单信息在改变之前 是 未提交的状态
      const isOldOrderBeforeWaittingToPay = oldOrder && oldOrder.offline === 0 && (oldOrder.order_status <= 3 || oldOrder.order_status === 10);

      // 线上订单在提交订单之后会因为下面的监听到执行到这里来,这里需要规避一下, 但是线下订单到这个页面的时候已经是待支付了
      const onlineOrderIsOrAfterWaittingToPay = order && order.offline === 0 && order.order_status > 2 && order.order_status !== 10;
      if (isOldOrderBeforeWaittingToPay && onlineOrderIsOrAfterWaittingToPay) return;

      this.queryingReturnExpressData = true;
      productService.orderReturnExpressSubmit(this.orderId, returnAddress)
        .then((data) => {
          this.sfReturnExpressPrice = data.return_express_amount;
          this.queryingReturnExpressData = false;
        })
        .catch(() => {
          this.queryingReturnExpressData = false;
        });

    },
    changeReceiveAddress(address) {
      this.returnAddress = address;
      this.submitReturnAddress(address);
      if (address.peer_address_id && address.peer_address_id === this.selectedSFAddress.peer_address_id) {
        // 为了兼容旧逻辑加的，当回寄地址编辑了地址库的地址，而且编辑的刚好是顺丰当前选中的地址，则重新提交一遍
        this.selectedSFAddress = address;
        this.recalculateSfPriceForChoosing(address)
          .then(() => {
            // 可能更改了地址库，需要重新刷新一下
            this.getAddresses(this.order);
          }).catch((e) => {
            if (e) console.log(e);
          });
      } else if (address.peer_address_id) {
        this.getAddresses(this.order);
      }

      // this.getAddresses(this.order);
    },
    submitReturnAddress(address) {
      address.user_order_id = this.orderId;
      Http.post('/order_return_address_add', address)
        .then(() => {
          this.getReturnExpressPrice(address);
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },

    // 获取同业信息
    getPeer() {
      if (User.isLogin()) {
        orderComfirmService.peerQuery().then((data) => {
          this.peer = data;
        }).catch((e) => {
          if (e) console.log(e);
        });
      }
    },

    // 重新计算选中的顺丰的价钱
    recalculateSfPriceForChoosing(address) {
      const { user_order_id } = this.order;
      const postData = {
        user_order_id,
        address: {
          addressee: address.addressee,
          mobile_phone: address.mobile_phone,
          province_code: address.province_code,
          city_code: address.city_code,
          county_code: address.county_code,
          detail_address: address.detail_address,
        },
      };
      return Http.post('/pickup_submit', postData)
        .then((data) => {
          this.pickUpAmountObj = data;
          this.order.order_pickup = [{ address }]; // 这里这样处理是为了上面SFService.getSfAddress里面遍历的时候能够取到值
          this.order.supplier_address = data.supplier_address;
        })
        .catch(() => {

          // 如果报错,则取消选中, 比如该地区不支持上门取件
          this.selectedSFAddress = {};
          this.pickUpAmountObj = { pickup_amount: 0 };
        });
    },

    // 订单刷新,主要是处理供应商地址变化
    refreshOrder() {
      return orderComfirmService.orderRefresh(this.orderId);
    },
    changeOrderStatus() {
      if ([1, 2, 10].indexOf(this.order.order_status) !== -1) {
        Http.post('/order_status_switch', { user_order_id: this.orderId }).then(() => {
          this.order.order_status = 3;
        });
      }
    },
    applicantDelete() {
      this.getOrderCoupons(this.orderId);
      if (this.getCurrentInsuranceType === 1 && this.order.offline === 0) {
        // 自选保险，重新获取一下价格
        this.$refs.userInsuranceCom.getInsurancePrice();
      }
    },

    handleShowRechargeDialog(showPayNowCheckbox = false) {
      this.rechargeDialogInfo.show = true;
      this.rechargeDialogInfo.showPayNowCheckbox = showPayNowCheckbox;
    },
    rechargeSuccess({ isPayNow, isGiveCoupon }) {
      this.rechargeDialog = false;
      this.getPeer();
      // 如果勾选了立即支付，并且没有赠送优惠券，则需要提交订单，否则刷新优惠券
      if (isPayNow && !isGiveCoupon) {
        this.commit({ notConfirmPay: true });
      } else {
        // 送券了，需要定位到优惠券，并晃动
        this.scrollToElAndShake('#order-comfirm #order-coupons');
        // 刷新优惠券
        this.getOrderCoupons(this.orderId, true);
      }
    },

    submitInsurance() {
      const { order } = this;
      if (this.getCurrentInsuranceType === 1 && this.insurance.user_insurance_form.insurance_id) {
        const protect_days = insuranceService.getProtectDays(
          this.current_user_insurance,
          this.insurance.user_insurance_form.insurance_day_index,
          this.insurance.user_insurance_form.over_day_index,
        );
        return this.$refs.userInsuranceCom.getInsurancePrice({ onlyCurrent: true }).then(() => Http.post('/insurance_submit', {
          user_order_id: order.user_order_id,
          case_code: this.current_user_insurance.case_code,
          start_date: this.insurance.user_insurance_form.start_date,
          protect_days,
          applicant_id_set: order.applicant.map(item => item.order_applicant_id),
        }));
      } else if (this.getCurrentInsuranceType === 2) {
        const priceChangePromise = this.$refs.platformInsuranceCom.platformInsuranceSubmit();
        return priceChangePromise;
      } 
      return Promise.resolve();
    },

    // 校验供应商地址是否变更，如果变更了，并且当前选择了地址，则需要重新计算价格
    checkSupplierAddressChange() {
      return new Promise((resolve, reject) => {
        if (this.selectedSFAddress.province_code) {
          // 选择了顺丰地址,判断当前订单供应商地址，和实际后台的供应商地址是否一致
          const oldSupplierAddress = this.order.supplier_address;
          orderingService.getOrderData(this.orderId).then((data) => {
            const newSupplierAddress = data.supplier_address;
            if (
              newSupplierAddress.province_code !== oldSupplierAddress.province_code ||
            newSupplierAddress.city_code !== oldSupplierAddress.city_code ||
            newSupplierAddress.county_code !== oldSupplierAddress.county_code ||
            newSupplierAddress.detail_address !== oldSupplierAddress.detail_address
            ) {
              utils.msgbox.alert(
                '顺丰寄送资料地址已变更，请点击确定刷新，重新确认。',
                '重要提示',
                {
                  confirmButtonText: '确认',
                  callback: (action) => {
                    if (action === 'confirm') {
                      // 重新计算价格
                      this.recalculateSfPriceForChoosing(this.selectedSFAddress);
                    }
                  },
                },
              );
              reject();
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });

    },
  },
  watch: {
    order: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.getAddresses(newVal, oldVal);
          this.getPeer();
        }
      },
    },
  },
  created() {


    // 从充值页回来的时候，如果带上了顺丰，要去掉这个参数
    if (this.$route.query.sf) {
      this.$router.replace({
        name: 'orderComfirm',
        params: {
          oid: this.orderId,
        },
      });
    }
    this.refreshOrder()
      .then(() => {
        this.getOrder()
          .then(() => {
            // 进到提交页，把订单状态更改为待支付
            this.changeOrderStatus();
            // 监听页面关闭
            window.onbeforeunload = (e) => {
              if (!this.layout.allowLeave) {
                const messgae = '确定要离开此页面吗？您所做的更改可能不会被保存。';
                e.preventDefault();
                e.returnValue = messgae;
                return messgae;
              }
            };
          });
      })
      .catch((e) => {
        if (e) console.log(e);
      });
    pcdService.getPcd().then(pcds => this.pcds = pcds).catch((e) => {
      if (e) console.log(e);
    });
  },
  destroyed() {
    window.onbeforeunload = undefined;
  },

  beforeRouteLeave(to, from, next) {
    if (this.layout.allowLeave) {
      next();
      return;
    }
    orderConfirmBackDialog.show({ date:
      this.otherOrderData.depart_date ?
        this.otherOrderData.depart_date.format('yyyy-MM-dd')
        : this.order.earliest_depart_date,
    }).then(() => {
      next();
    }).catch(() => {
      next(false);
    });
  },
};
</script>

<style lang="less">
@import  '../../assets/less/variable';
#order-comfirm {
  padding-top: 20px;
  padding-bottom: 124px;
  width: 1200px;
  padding-right: 320px;
  .page-content{
    .customer-phone{
      padding-left: 16px;
      display: flex;
      align-items: center;
      line-height: 1;
      margin-bottom: 20px;
      .icon{
        width: 18px;
        margin-right: 6px;
      }
      .customer-phone-label{
        color: #5F666E;
        font-size: 14px;
        margin-right: 8px;
      }
      .customer-phone-value{
        color: #2F333D;
        font-size: 14px;
        font-weight: 600;
      }
    }
  }
  .page-fixed-right{
    position: fixed;
    top: 88px;
    right: calc(~'((100% - 1200px) / 2)');
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/OrderComfirm.vue